import React from "react";
import { FormIcon } from "../Icons/FormIcon";
import { QuizIcon } from "../Icons/QuizIcon";
import { WritingIcon } from "../Icons/WritingIcon";
import { PracticeIcon } from "../Icons/PracticeIcon";
import { ReadingIcon } from "../Icons/ReadingIcon";
import { VideoIcon } from "../Icons/VideoIcon";

export const DynoIcon = ({ dynoType }) => {
  switch (dynoType) {
    case "Reading":
      return <ReadingIcon />;
    case "Form":
      return <FormIcon />;
    case "Quiz":
      return <QuizIcon />;
    case "Practice":
      return <PracticeIcon />;
    case "Writing Assignment":
      return <WritingIcon />;
    case "Writing Submission":
      return <WritingIcon />;
    case "Video":
      return <VideoIcon />;
    default:
      return <ReadingIcon />;
  }
};
